const searchQuery = state => state.searchQuery
const searchContext = state => state.searchContext
const contexts = () => ['Courses', 'Learning Paths', 'Videos']
const coursesResultCount = state => state.coursesResultCount
const playlistsResultCount = state => state.playlistsResultCount
const videosResultCount = state => state.videosResultCount
const viewStyle = state => state.viewStyle
const isFiltersCollapsed = state => state.isFiltersCollapsed

export default {
  searchQuery,
  searchContext,
  contexts,
  coursesResultCount,
  playlistsResultCount,
  videosResultCount,
  viewStyle,
  isFiltersCollapsed,
}
